import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ChangeEvent } from 'react';

export interface Props {
  name?: string;
  selected: boolean;
  label: string;
  unSelectedIcon: IconProp;
  unSelectedIconClasses: string;
  selectedIcon: IconProp;
  selectedIconClasses: string;
  setSelected(e: ChangeEvent<HTMLInputElement>): void;
  trackingCallback?(event: string, params?: Record<string, unknown>): void;
}

export const IconCheckbox = ({
  name,
  selected,
  label,
  unSelectedIcon,
  unSelectedIconClasses,
  selectedIcon,
  selectedIconClasses,
  setSelected,
  trackingCallback,
}: Props): JSX.Element => {

  const handleSelect = (e: ChangeEvent<HTMLInputElement>): void => {
    if (trackingCallback) {
      const trackingProps = {
        elementId: 'icon-checkbox',
        elementText: label
      };
      trackingCallback('clicked-button', trackingProps);
    }

    setSelected(e);
  };

  return (
    <label
      className='bg-transparent relative block rounded-full w-full cursor-pointer select-none transition-all'
    >
      <span>
        {selected && (<FontAwesomeIcon icon={selectedIcon} className={`mt-0 align-middle ${selectedIconClasses}`} />)}
        {!selected && (<FontAwesomeIcon icon={unSelectedIcon} className={`mt-0 align-middle ${unSelectedIconClasses}`} />)}
        <input
          type='checkbox'
          className='hidden mt-0 align-middle bg-transparent'
          checked={selected}
          name={name}
          onChange={handleSelect}
        />
      </span>
      <span className='ml-2 mt-0.25 align-middle inline-block lg:text-sm text-almostBlack'>
        {label}
      </span>
    </label>
  )
};
